import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonDatetime, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonList, IonLoading, IonPage, IonPopover, IonRefresher, IonRefresherContent, IonRow, IonSelect, IonSelectOption, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { alertCircle, arrowBack, arrowForwardCircle, checkmarkCircle, time, trash, chatbubblesOutline, calendarOutline } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { deletarMensagem as deletarMensagemService, getEstatisticasMensagens, getMensagensEmpresa, requestService, urlBaseCore } from '../../../../../Utils/Services';
import GridStatus from '../../../../../components/Grid/GridStatus';
import '../MensagensLayout.css';
import "./PainelMensagens.css";

type Props = {
  abrirMenu: boolean;
  projetoid: string;
  empresaid: string;
  configs: Object;
  abrirInserirAgendamento: boolean;
  onDismiss: () => void;
};

const PainelMensagens: React.FC<Props> = (props: Props) => {
  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaMensagens, setListaMensagens] = useState<any>([]);
  const [nextToken, setNextToken] = useState<string | null>(null);
  const [carregandoMais, setCarregandoMais] = useState<boolean>(false);
  const [estatisticas, setEstatisticas] = useState<any>({});
  const [filtroStatus, setFiltroStatus] = useState("todos");
  const [filtroCampanha, setFiltroCampanha] = useState("todas");
  const [listaCampanhas, setListaCampanhas] = useState<any>([]);
  const [dataFiltro, setDataFiltro] = useState<string>(() => {
    // Inicializa com a data de hoje no formato YYYY-MM-DD
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  });
  const [dataFiltroBr, setDataFiltroBr] = useState<string>(() => {
    // Inicializa com a data de hoje no formato brasileiro
    const hoje = new Date();
    return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(hoje);
  });

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const { loja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { setEsconderMenu, setNomeMenu } = useContext(MessageContext);
  const [mostartAlerta] = useIonAlert();

  // Refs para popover de data
  const popoverData = useRef<HTMLIonPopoverElement>(null);
  const [showModalData, setShowModalData] = useState(false);

  useIonViewDidEnter(async () => {
    setEsconderMenu(false);
    setNomeMenu("Painel de Mensagens");
    await carregarCampanhas()
    carregarDados();
  });



  const carregarDados = async () => {
    await Promise.all([
      carregarMensagens(),
      carregarEstatisticas(),
    ]);
  };

  // Converte o nextToken (objeto ou string) para base64 de JSON, como o backend espera
  const encodeNextToken = (token: any): string | null => {
    try {
      if (!token) return null;
      // Se vier como objeto (pk/sk)
      if (typeof token === 'object') {
        const json = JSON.stringify(token);
        return btoa(unescape(encodeURIComponent(json)));
      }
      // Se já vier como string (por segurança, tenta detectar se já é base64)
      if (typeof token === 'string') {
        // Caso a API algum dia envie string JSON, ainda assim re-encode
        try {
          const maybeObj = JSON.parse(token);
          const json = JSON.stringify(maybeObj);
          return btoa(unescape(encodeURIComponent(json)));
        } catch {
          // Assume que já é base64
          return token;
        }
      }
      return null;
    } catch (e) {
      console.error('Falha ao codificar nextToken:', e);
      return null;
    }
  };

  const carregarMensagens = async () => {
    try {
      setShowLoading(true);

      let url = getMensagensEmpresa.url.replace("{empresaid}", loja.replaceAll(/#/g, '%23'));

      // Adicionar filtros na URL
      const params = new URLSearchParams();
      if (filtroStatus !== "todos") {
        params.append('status', filtroStatus);
      }
      if (filtroCampanha !== "todas") {
        params.append('campanha', filtroCampanha);
      }
      if (dataFiltro) {
        params.append('data', dataFiltro);
      }

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: 'GET',
            timeout: 15000,
          },
          history,
          (response) => {
            const itens = response.Items || [];
            setListaMensagens(itens);
            const token = response?.pagination?.nextToken || null;
            setNextToken(token);
            resolve();
          },
          (error) => {
            console.error("Erro ao carregar mensagens:", error);
            if (error.status === 404) {
              setListaMensagens([]);
              setNextToken(null);
              resolve();
            } else {
              reject(new Error(error.message || "Erro ao carregar mensagens"));
            }
          }
        );
      });

    } catch (error: any) {
      console.error("Erro ao carregar mensagens:", error);
      setTextToast("Erro ao carregar mensagens.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  };

  const carregarMaisMensagens = async (ev?: CustomEvent) => {
    if (!nextToken || carregandoMais) {
      if (ev) (ev.target as HTMLIonInfiniteScrollElement).complete();
      return;
    }
    try {
      setCarregandoMais(true);

      let url = getMensagensEmpresa.url.replace("{empresaid}", loja.replaceAll(/#/g, '%23'));

      const params = new URLSearchParams();
      if (filtroStatus !== "todos") {
        params.append('status', filtroStatus);
      }
      if (filtroCampanha !== "todas") {
        params.append('campanha', filtroCampanha);
      }
      if (dataFiltro) {
        params.append('data', dataFiltro);
      }
      if (nextToken) {
        const encoded = encodeNextToken(nextToken);
        if (encoded) {
          params.append('nextToken', encoded);
        }
      }
      // evita cache do navegador/CDN
      params.append('_', Date.now().toString());

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const urlDebug = url;
      console.log('[Mensagens][Paginar] URL:', urlDebug);
      console.log('[Mensagens][Paginar] nextToken (orig):', nextToken);
      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: 'GET',
            timeout: 15000,
          },
          history,
          (response) => {
            const novos = response.Items || [];
            setListaMensagens((prev: any[]) => {
              // evita duplicar itens (mesmo id)
              const ids = new Set(prev.map((m: any) => m.id || m.pk));
              const filtrados = novos.filter((m: any) => !ids.has(m.id || m.pk));
              return [...prev, ...filtrados];
            });
            const token = response?.pagination?.nextToken || null;
            setNextToken(token);
            resolve();
          },
          (error) => {
            console.error("Erro ao carregar mais mensagens:", error);
            reject(new Error(error.message || "Erro ao carregar mais mensagens"));
          }
        );
      });
    } catch (e) {
      // noop
    } finally {
      setCarregandoMais(false);
      if (ev) (ev.target as HTMLIonInfiniteScrollElement).complete();
    }
  };

  const carregarEstatisticas = async () => {
    try {
      let url = getEstatisticasMensagens.url.replace("{empresaid}", loja.replaceAll(/#/g, '%23'));

      // Adicionar parâmetro de data se selecionado
      const params = new URLSearchParams();
      if (filtroStatus !== "todos") {
        params.append('status', filtroStatus);
      }
      if (filtroCampanha !== "todas") {
        params.append('campanha', filtroCampanha);
      }
      if (dataFiltro) {
        params.append('data', dataFiltro);
      }

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: 'GET',
            timeout: 15000,
          },
          history,
          (response) => {
            setEstatisticas(response);
            resolve();
          },
          (error) => {
            console.error("Erro ao carregar estatísticas:", error);
            setEstatisticas({});
            resolve(); // Não falhar se não conseguir carregar estatísticas
          }
        );
      });

    } catch (error: any) {
      console.error("Erro ao carregar estatísticas:", error);
      setEstatisticas({});
    }
  };

  const carregarCampanhas = async () => {
    try {
      const url = `${urlBaseCore.url}/campanhas/empresa/${loja.replaceAll(/#/g, '%23')}`;

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: 'GET',
            timeout: 15000,
          },
          history,
          (response) => {
            if (response.Items) {
              setListaCampanhas(response.Items);
            } else {
              setListaCampanhas([]);
            }
            resolve();
          },
          (error) => {
            console.error("Erro ao carregar campanhas:", error);
            setListaCampanhas([]);
            resolve();
          }
        );
      });

    } catch (error: any) {
      console.error("Erro ao carregar campanhas:", error);
      setListaCampanhas([]);
    }
  };

  const deletarMensagem = async (indice: number) => {
    mostartAlerta({
      backdropDismiss: false,
      header: 'Remover mensagem',
      message: 'Deseja <strong>remover</strong> esta mensagem?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Confirmar',
          cssClass: 'primary',
          handler: async () => {
            try {
              setShowLoading(true);

              const mensagem = listaMensagens[indice];

              console.log("********mensagem", mensagem.pk);

              const url = deletarMensagemService.url.replace("{id}", mensagem.pk.replaceAll(/#/g, '%23'));

              await new Promise<void>((resolve, reject) => {
                requestService(
                  url,
                  {
                    method: 'DELETE',
                    body: JSON.stringify({
                      pk: mensagem.pk,
                      sk: mensagem.sk,
                      empresaid: loja
                    }),
                    timeout: 15000,
                  },
                  history,
                  (response) => {
                    const novasMensagens = listaMensagens.filter((_: any, i: number) => i !== indice);
                    setListaMensagens(novasMensagens);
                    setTextToast("Mensagem removida com sucesso.");
                    setShowToast(true);

                    // Recarregar estatísticas após excluir mensagem
                    carregarEstatisticas();

                    resolve();
                  },
                  (error) => {
                    console.error("Erro ao deletar mensagem:", error);
                    setTextToast(error.message || "Erro ao deletar mensagem.");
                    setShowToast(true);
                    reject(new Error(error.message || "Erro ao deletar mensagem"));
                  }
                );
              });

            } catch (error: any) {
              console.error("Erro ao deletar mensagem:", error);
            } finally {
              setShowLoading(false);
            }
          }
        }
      ]
    });
  };



  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'aceita_meta': return { icon: checkmarkCircle, color: 'success' };
      case 'bloqueada_oficial':
      case 'nao_confirmado': return { icon: alertCircle, color: 'warning' };
      case 'recusada_meta': return { icon: alertCircle, color: 'danger' };
      case 'enfileirado_whatsapp': return { icon: arrowForwardCircle, color: 'tertiary' };
      case 'aguardando_processamento':
        return { icon: time, color: 'warning' };
      case 'enviado_para_fila':
        return { icon: arrowForwardCircle, color: 'tertiary' };
      case 'erro_processamento':
        return { icon: alertCircle, color: 'danger' };
      case 'erro_envio_whatsapp':
        return { icon: alertCircle, color: 'danger' };
      case 'enviado_whatsapp':
        return { icon: checkmarkCircle, color: 'success' };
      default:
        return { icon: time, color: 'medium' };
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'aceita_meta': return 'Aceita pela Meta (não confirma entrega)';
      case 'bloqueada_oficial': return 'Bloqueada no Oficial';
      case 'nao_confirmado': return 'Não confirmado — não reenviar';
      case 'recusada_meta': return 'Recusada pela Meta';
      case 'enfileirado_whatsapp': return 'Na fila do WhatsApp';
      case 'aguardando_processamento':
        return 'Aguardando';
      case 'enviado_para_fila':
        return 'Na Fila';
      case 'erro_processamento':
        return 'Erro';
      case 'erro_envio_whatsapp':
        return 'Erro envio WhatsApp';
      case 'enviado_whatsapp':
        return 'Enviado';
      default:
        return status;
    }
  };

  const formatarDataHora = (dataISO: string) => {
    if (!dataISO) return '-';
    try {
      const data = new Date(dataISO);
      return data.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return '-';
    }
  };

  // Função para abrir popover de seleção de data
  const openPopoverData = (e: any) => {
    popoverData.current!.event = e;
    setShowModalData(true);
  };

  const onRefresh = async (event: any) => {
    await carregarDados();
    event.detail.complete();
  };

  const loadMensagens = () => {
    if (!listaMensagens || listaMensagens.length === 0) {
      return <div className="mensagens-empty"><IonIcon icon={chatbubblesOutline} aria-hidden="true" />
        <h3>Nenhuma mensagem encontrada</h3><p>As mensagens do período e dos filtros selecionados aparecerão aqui.</p>
      </div>;
    }
    return <table className="mensagens-table painel-mensagens-table" aria-label="Mensagens da empresa">
      <thead><tr><th>Destinatário</th><th>Data e hora</th><th>Status</th><th>Mensagem</th><th className="mensagens-actions-heading">Ações</th></tr></thead>
      <tbody>{listaMensagens.map((mensagem: any, index: number) => {
        const statusInfo = getStatusIcon(mensagem.status);
        return <tr key={mensagem.id || index}>
          <td className="mensagem-recipient"><strong>{mensagem.nome || 'Nome não informado'}</strong><small>{mensagem.telefone}</small></td>
          <td className="mensagem-date">{formatarDataHora(mensagem.dataExecucao)}</td>
          <td className="mensagem-status"><GridStatus tone={statusInfo.color === 'success' ? 'success' : statusInfo.color === 'warning' || statusInfo.color === 'danger' ? 'warning' : 'neutral'} icon={statusInfo.icon}>{getStatusLabel(mensagem.status)}</GridStatus></td>
          <td className="mensagem-text"><span>{mensagem.mensagem?.substring(0, 50)}{mensagem.mensagem?.length > 50 ? '...' : ''}</span><small>Delay: {mensagem.delay}s</small></td>
          <td className="mensagens-row-actions"><IonButton fill="clear" className="mensagens-delete" aria-label={`Excluir mensagem de ${mensagem.nome || 'cliente não informado'}`}
            onClick={() => deletarMensagem(index)} hidden={acessos?.configuracoes !== 'edicao' || (mensagem.status !== 'aguardando_processamento')}>
            <IonIcon icon={trash} aria-hidden="true" />
          </IonButton></td>
        </tr>;
      })}</tbody>
    </table>;
  };

  return (
    <IonPage className="PainelMensagens mensagens-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="mensagens-toolbar">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Painel de Mensagens</IonTitle>
        </IonToolbar>

      </IonHeader>

      <IonContent fullscreen={false}>
        <IonRefresher slot="fixed" onIonRefresh={onRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <div className="mensagens-container">
          <div className="mensagens-page-heading"><div><h1>Painel de mensagens</h1><p>Acompanhe a programação e o status das mensagens enviadas aos clientes.</p></div></div>
          <section className="mensagens-filter-card" aria-label="Filtros das mensagens">
            <h2>Filtrar mensagens</h2>
            <div className="painel-mensagens-filters">
              <div className="mensagens-field"><span>Data</span><button type="button" className="mensagens-date-button" onClick={openPopoverData}><IonIcon icon={calendarOutline} aria-hidden="true" />{dataFiltroBr || "Selecione uma data"}</button></div>
              <div className="mensagens-field"><span>Status</span><IonSelect aria-label="Status das mensagens"
                    value={filtroStatus}
                    onIonChange={(e: any) => setFiltroStatus(e.detail.value)}
                    placeholder="Status"
                  >
                    <IonSelectOption value="todos">Todos os Status</IonSelectOption>
                    <IonSelectOption value="aguardando_processamento">Aguardando</IonSelectOption>
                    <IonSelectOption value="enviado_para_fila">Na Fila</IonSelectOption>
                    <IonSelectOption value="erro_processamento">Com Erro</IonSelectOption>
                    <IonSelectOption value="enviado_whatsapp">Enviado</IonSelectOption>
                    <IonSelectOption value="aceita_meta">Aceita pela Meta</IonSelectOption>
                    <IonSelectOption value="bloqueada_oficial">Bloqueada no Oficial</IonSelectOption>
                    <IonSelectOption value="recusada_meta">Recusada pela Meta</IonSelectOption>
                    <IonSelectOption value="nao_confirmado">Não confirmado</IonSelectOption>
                  </IonSelect></div>
              <div className="mensagens-field"><span>Campanha</span><IonSelect aria-label="Campanha"
                    value={filtroCampanha}
                    onIonChange={(e: any) => setFiltroCampanha(e.detail.value)}
                    placeholder="Campanha"
                  >
                    <IonSelectOption value="todas">Todas as Campanhas</IonSelectOption>
                    {listaCampanhas.map((campanha: any) => (
                      <IonSelectOption key={campanha.pk} value={campanha.pk}>
                        {campanha.nome}
                      </IonSelectOption>
                    ))}
                  </IonSelect></div>
              <IonButton className="mensagens-primary" onClick={async () => await carregarDados()}>Aplicar filtros</IonButton>
            </div>
          </section>
          <section className="painel-mensagens-summary" aria-label="Estatísticas do dia">
            <h2>Estatísticas do dia {dataFiltroBr && `(${dataFiltroBr})`}</h2>
            <div className="mensagens-metrics">
              <div className="mensagens-metric"><span className="mensagens-metric-icon is-warning"><IonIcon icon={time} aria-hidden="true" /></span><div><span>Aguardando</span><strong>{estatisticas.aguardando || 0}</strong></div></div>
              <div className="mensagens-metric"><span className="mensagens-metric-icon is-queue"><IonIcon icon={arrowForwardCircle} aria-hidden="true" /></span><div><span>Na fila</span><strong>{estatisticas.fila || 0}</strong></div></div>
              <div className="mensagens-metric"><span className="mensagens-metric-icon is-error"><IonIcon icon={alertCircle} aria-hidden="true" /></span><div><span>Com erro</span><strong>{estatisticas.erro || 0}</strong></div></div>
              <div className="mensagens-metric"><span className="mensagens-metric-icon is-success"><IonIcon icon={checkmarkCircle} aria-hidden="true" /></span><div><span>Enviadas</span><strong>{estatisticas.enviadas || 0}</strong></div></div>
            </div>
          </section>
          <section className="mensagens-grid" aria-label="Mensagens">
            <div className="mensagens-grid-heading"><span className="mensagens-section-icon"><IonIcon icon={chatbubblesOutline} aria-hidden="true" /></span><div><h2>Mensagens</h2><p>{listaMensagens?.length || 0} mensagem(ns) carregada(s)</p></div></div>
            {loadMensagens()}
          </section>
        <IonInfiniteScroll
          onIonInfinite={async (ev) => await carregarMaisMensagens(ev)}
          threshold="100px"
          position="bottom"
          disabled={!nextToken}
        >
          <IonInfiniteScrollContent
            loadingSpinner="bubbles"
            loadingText="Carregando mais mensagens..."
          ></IonInfiniteScrollContent>
        </IonInfiniteScroll>

        </div>

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          spinner="circles"
        />

        <IonPopover ref={popoverData}
          isOpen={showModalData}
          onDidDismiss={() => setShowModalData(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {
                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );

                  setDataFiltro(data); // Formato YYYY-MM-DD para API
                  setDataFiltroBr(dataFormatada); // Formato brasileiro para exibição
                }
                setShowModalData(false);
              }}></IonDatetime>
          </IonContent>
        </IonPopover >
      </IonContent>
    </IonPage>
  );
};

export default PainelMensagens;
